import { getStoredAuthorization, ajax } from "@tm/utils"
import { getBundleParams } from "../../../utils"
import { ImagePathsRequest } from "./model"
import { mapImagePathResponse } from "./mapper"

export async function load2DImages(request: ImagePathsRequest) {
    const url = `${getServiceUrl()}/GetImagePaths`
    const authorization = getStoredAuthorization()
    const body = request

    const response = await ajax({ url, body, authorization })
    const imagePaths = mapImagePathResponse(response)
    if (!imagePaths) {
        throw new Error()
    }

    return imagePaths
}

function getServiceUrl(): string {
    const toolkitParams = getBundleParams()
    return toolkitParams.vehicleServiceUrl
}
